import { Link } from "react-router-dom";
import Badge from "../../components/ui/Badge";
import { formatHours } from "../../utils/date";

import { hasApprovedOvertime } from "./overtimeUtils";

// "Overtime: Yes" on a day with approved overtime (hours in the tooltip).
const OvertimeTag = ({ day }) => {
  if (!hasApprovedOvertime(day)) return null;
  const hours = Number(day.overtimeHours ?? 0);

  return (
    <Link
      to="/me/overtime"
      className="text-decoration-none"
      title={
        hours > 0
          ? `Approved overtime: ${formatHours(hours)}`
          : "Approved overtime"
      }
    >
      <Badge tone="blue" icon="bi-stopwatch">
        Overtime: Yes
      </Badge>
    </Link>
  );
};

export default OvertimeTag;
